import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: (theme, isActive, subTitle) => ({
    borderRadius: 5,
    borderWidth: isActive ? 2 : 1,
    padding: isActive ? 0 : 10,
    borderColor: isActive ? theme.colors.radioButton : theme.colors.optionBorderColor,
    justifyContent: 'center',
    alignItems: 'center',
  }),
});
